// Historical surplus / (deficit) for prior FYs. Display-only — hardcoded
// per BRIEF §6 ("not from Sheet"). Years are absolute, not derived from
// the editable base year, since they're a fixed historical record.
//
// Source: CCAANZ audited annuals + H1 management accounts.

export type HistoricalYear = {
  year: string;
  surplus: number;
  partial?: boolean;
  note?: string;
};

export const HISTORICAL: HistoricalYear[] = [
  { year: 'FY2022', surplus: 10874 },
  { year: 'FY2023', surplus: 116785 },
  { year: 'FY2024', surplus: 226422 },
  { year: 'FY2025', surplus: 126700 },
];
